import { useState } from 'react';
import { convertToDayJs, getCurrentTimeDiff, isNil } from 'shared/src/utils';
import { useForegroundInterval } from 'shared/src/hooks';

export const useRemainTimeTextFormat = (time: string | null) => {
  const [remainText, setRemainText] = useState<string>('');
  const [isTimeOver, setIsTimeOver] = useState<boolean>(false);
  const [isOneHourRemaining, setIsOneHourRemaining] = useState<boolean>(false);

  useForegroundInterval(() => {
    if (isNil(time)) return;

    const limitTime = convertToDayJs(time);

    const diffSecond = getCurrentTimeDiff(limitTime, 'second');
    const diffHourText = Math.abs(getCurrentTimeDiff(limitTime, 'hour'));
    const diffMinute = Math.abs(getCurrentTimeDiff(limitTime, 'minute'));
    const diffMinuteText = diffMinute - diffHourText * 60;
    const diffSecondText =
      Math.abs(getCurrentTimeDiff(limitTime, 'second')) - diffMinute * 60;

    const timeOver = diffSecond > 0;

    const diffDay = Math.abs(getCurrentTimeDiff(limitTime, 'day'));
    const text =
      diffHourText >= 24
        ? `${diffDay}일`
        : `${diffHourText < 10 ? `0${diffHourText}` : diffHourText} : ${diffMinuteText < 10 ? `0${diffMinuteText}` : diffMinuteText} : ${diffSecondText < 10 ? `0${diffSecondText}` : diffSecondText}`;
    setIsTimeOver(timeOver);
    setRemainText(text);
    if (!timeOver) {
      setIsOneHourRemaining(diffHourText === 0);
    }
  }, !isNil(time) && !isTimeOver ? 1000 : null);

  return {
    text: remainText,
    isTimeOver,
    isOneHourRemaining,
  };
};
